import { Component, Input, AfterViewInit, EventEmitter, ElementRef, Output, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild, ViewContainerRef, NgZone, Renderer2, ViewRef } from '@angular/core';

import { AnimationEvent } from '../animations/animations.interface';
export class AlertComponent implements AfterViewInit, OnDestroy {
public dismissibleClass = 'alert-dismissible';
public isDismissible = true;
public remove = false;
public removed: boolean;
public type = 'alert';
private removeButtonListener: Function;
public backgroundColor = 'danger';
/**
 * @param {?} value
 * @return {?}
 */
public set callout(value: boolean) {
    this.type = value ? 'callout' : 'alert';
  }
public color: string;
public dismissOnTimeout: number;
/**
 * @param {?} value
 * @return {?}
 */
public set _isDismissible(value: boolean) {
    this.isDismissible = value;
    if(value) {
      this.dismissibleClass = `${this.type}-dismissible`;
    } else {
      this.dismissibleClass = '';
    }
  }
public styleClass = '';
public onCollapseStart = new EventEmitter();
public onCollapseDone = new EventEmitter();
private removeButtonElement: ElementRef;
private containerElementRef: ViewContainerRef;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} ngZone
 * @param {?} renderer2
 * @param {?} viewContainerRef
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private ngZone: NgZone,
private renderer2: Renderer2,
private viewContainerRef: ViewContainerRef
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      if(this.dismissOnTimeout) {
        setTimeout(() => {
          if(!( /** @type {?} */((this.changeDetectorRef as ViewRef))).destroyed) {
            this.remove = true;
            this.changeDetectorRef.detectChanges();
          }
        }, this.dismissOnTimeout);
      }
      if(this.removeButtonElement) {
        this.removeButtonListener = this.renderer2.listen(this.removeButtonElement.nativeElement, 'click', (event: Event) => {
          this.remove = true;
          this.changeDetectorRef.detectChanges();
        });
      }
    });
  }
/**
 * \@method ngOnDesroy
 * @return {?}
 */
ngOnDestroy() {
    if(this.removeButtonListener) {
      this.removeButtonListener();
    }
  }
/**
 * [collapseStart description]
 * \@method collapseStart
 * @param {?} event
 * @return {?}
 */
public collapseStart(event: AnimationEvent): void {
    this.onCollapseStart.emit(event);
  }
/**
 * [collapseDone description]
 * \@method collapseDone
 * @param {?} event
 * @return {?}
 */
public collapseDone(event: AnimationEvent): void {
    if(event.toState === '1') {
      if(this.removeButtonListener) {
        this.removeButtonListener();
      }
      this.removed = true;
      this.viewContainerRef.clear();
      this.changeDetectorRef.detectChanges();
    }
    this.onCollapseDone.emit(event);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-alert',
  template: `
    <div *ngIf="!removed" [collapseAnimation]="remove" (collapseAnimation.start)="collapseStart($event)" (collapseAnimation.done)="collapseDone($event)">
      <div [mkColor]="backgroundColor" mkColorProperty="background-color" [mkColorPrefix]="type" [mkFontColor]="color" [ngClass]="[styleClass, dismissibleClass, type]">
        <button *ngIf="isDismissible" type="button" class="close" #removeButtonElement>&times;</button>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .callout-dismissable,
    .callout-dismissible {
      padding-right: 35px;
    }

    .callout-dismissable .close,
    .callout-dismissible .close {
        position: relative;
        top: -2px;
        right: -21px;
        color: inherit;
    }

    .callout .close {
      color: #000;
      opacity: 0.2;
      filter: alpha(opacity=20);
    }

    .callout .icon {
      margin-right: 10px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: NgZone, },
{type: Renderer2, },
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'backgroundColor': [{ type: Input },],
'callout': [{ type: Input },],
'color': [{ type: Input },],
'dismissOnTimeout': [{ type: Input },],
'_isDismissible': [{ type: Input, args: ['isDismissible', ] },],
'styleClass': [{ type: Input },],
'onCollapseStart': [{ type: Output },],
'onCollapseDone': [{ type: Output },],
'removeButtonElement': [{ type: ViewChild, args: ['removeButtonElement', ] },],
'containerElementRef': [{ type: ViewChild, args: ['containerElementRef', { read: ViewContainerRef }, ] },],
};
}

function AlertComponent_tsickle_Closure_declarations() {
/** @type {?} */
AlertComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AlertComponent.ctorParameters;
/** @type {?} */
AlertComponent.propDecorators;
/** @type {?} */
AlertComponent.prototype.dismissibleClass;
/** @type {?} */
AlertComponent.prototype.isDismissible;
/** @type {?} */
AlertComponent.prototype.remove;
/** @type {?} */
AlertComponent.prototype.removed;
/** @type {?} */
AlertComponent.prototype.type;
/** @type {?} */
AlertComponent.prototype.removeButtonListener;
/** @type {?} */
AlertComponent.prototype.backgroundColor;
/** @type {?} */
AlertComponent.prototype.color;
/** @type {?} */
AlertComponent.prototype.dismissOnTimeout;
/** @type {?} */
AlertComponent.prototype.styleClass;
/** @type {?} */
AlertComponent.prototype.onCollapseStart;
/** @type {?} */
AlertComponent.prototype.onCollapseDone;
/** @type {?} */
AlertComponent.prototype.removeButtonElement;
/** @type {?} */
AlertComponent.prototype.containerElementRef;
/** @type {?} */
AlertComponent.prototype.changeDetectorRef;
/** @type {?} */
AlertComponent.prototype.ngZone;
/** @type {?} */
AlertComponent.prototype.renderer2;
/** @type {?} */
AlertComponent.prototype.viewContainerRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
